import XIcon from 'static/images/blackX.svg'

// Brand logos are static per platform and were previously served via the social
// accounts API (social_account_icon_url). They live on a public CDN, so we pin
// the URLs here and no longer depend on that (soon to be removed) endpoint.
// Twitter/X renders from a bundled asset, matching the rest of the app.
const ICON_BASE = 'https://6c4d983c21df528ffe2b-e5253708f2049a294c31680fda239035.ssl.cf2.rackcdn.com/socialLogos'

const ICONS = {
  twitter: XIcon,
  instagram: `${ICON_BASE}/icon_instagram_112.png`,
  tiktok: `${ICON_BASE}/icon_tiktok_112.png`,
  youtube_channel: `${ICON_BASE}/icon_youtube_112.png`,
  pinterest: `${ICON_BASE}/icon_pinterest_112.png`,
  snapchat: `${ICON_BASE}/icon_snapchat_112.png`
}

export const SocialPlatformIcon = ({ type, className, alt = type }) => (
  <img src={ICONS[type]} className={className} alt={alt} aria-hidden="true" />
)
